export default __webpack_public_path__ + "static/media/refresh-illustration.a33e0927.webp";